import { TypeOrNull } from "./../../model/index";
import axios from "axios";
import {
  DevelopmentPlan,
  DevelopmentPlanItem,
  DevelopmentPlanItemResponse,
  DevelopmentPlanQueryParams,
  DevelopmentPlanTemplate,
  EmployeeAssessmentReport,
  EmployeeAssessmentsReport,
  PeopleListEmployee,
} from "../../model/people";

export const doPeopleFetchApiCall = ({
  companyId,
  departmentId,
  params,
}: {
  companyId: number;
  departmentId: number;
  params?: { q?: TypeOrNull<string> };
}) => {
  return axios.get<PeopleListEmployee[]>(
    `/api/companies/${companyId}/departments/${departmentId}/people`,
    { params }
  );
};

export const doDevelopmentPlanTemplatesFetchApiCall = (companyId: number) =>
  axios.get<DevelopmentPlanTemplate[]>(
    `/api/companies/${companyId}/development_plan_templates`
  );

export const doDevelopmentPlanTemplateFetchApiCall = ({
  companyId,
  templateId = 1,
}: {
  companyId: number;
  templateId?: number;
}) =>
  axios.get<DevelopmentPlanTemplate>(
    `/api/companies/${companyId}/development_plan_templates/${templateId}`
  );

export const doEmployeeDevelopmentPlansFetchApiCall = ({
  companyId,
  employeeId,
  params,
}: {
  companyId: number;
  employeeId: number;
  params?: DevelopmentPlanQueryParams;
}) =>
  axios.get<DevelopmentPlan[]>(
    `/api/companies/${companyId}/employees/${employeeId}/development_plans`,
    { params }
  );

export const doEmployeeDevelopmentPlanCreationApiCall = ({
  companyId,
  employeeId,
  developmentPlanTemplateId = 1,
}: {
  companyId: number;
  employeeId: number;
  developmentPlanTemplateId?: number;
}) =>
  axios.post<DevelopmentPlan>(
    `/api/companies/${companyId}/employees/${employeeId}/development_plans`,
    { developmentPlanTemplateId }
  );

export const doEmployeeDevelopmentPlanDeletionApiCall = ({
  companyId,
  employeeId,
  developmentPlanId,
}: {
  companyId: number;
  employeeId: number;
  developmentPlanId?: number;
}) =>
  axios.delete<DevelopmentPlan>(
    `/api/companies/${companyId}/employees/${employeeId}/development_plans/${developmentPlanId}`
  );

export const doEmployeeDevelopmentPlanFetchApiCall = ({
  companyId,
  employeeId,
  developmentPlanId,
}: {
  companyId: number;
  employeeId: number;
  developmentPlanId: number;
}) =>
  axios.get<DevelopmentPlan>(
    `/api/companies/${companyId}/employees/${employeeId}/development_plans/${developmentPlanId}`
  );

export const doEmployeeDevelopmentPlanCompletionApiCall = ({
  companyId,
  employeeId,
  developmentPlanId,
  revert = false,
}: {
  companyId: number;
  employeeId: number;
  developmentPlanId: number;
  revert?: boolean;
}) =>
  axios.put<DevelopmentPlan>(
    `/api/companies/${companyId}/employees/${employeeId}/development_plans/${developmentPlanId}/completed`,
    { revert }
  );

export const doEmployeeDevelopmentPlanItemsFetchApiCall = ({
  companyId,
  employeeId,
  developmentPlanId,
}: {
  companyId: number;
  employeeId: number;
  developmentPlanId: number;
}) =>
  axios.get<DevelopmentPlanItem[]>(
    `/api/companies/${companyId}/employees/${employeeId}/development_plans/${developmentPlanId}/items`
  );

export const doEmployeeDevelopmentPlanItemCreationApiCall = ({
  companyId,
  employeeId,
  developmentPlanId,
  developmentPlanTemplateItemId,
  value,
}: {
  companyId: number;
  employeeId: number;
  developmentPlanId: number;
  developmentPlanTemplateItemId: number;
  value: string;
}) =>
  axios.post<DevelopmentPlanItemResponse>(
    `/api/companies/${companyId}/employees/${employeeId}/development_plans/${developmentPlanId}/items`,
    { developmentPlanTemplateItemId, value }
  );

export const doEmployeeDevelopmentPlanItemFetchApiCall = ({
  companyId,
  employeeId,
  developmentPlanId,
  itemId,
}: {
  companyId: number;
  employeeId: number;
  developmentPlanId: number;
  itemId: number;
}) =>
  axios.post<DevelopmentPlanItem>(
    `/api/companies/${companyId}/employees/${employeeId}/development_plans/${developmentPlanId}/items/${itemId}`
  );

export const doEmployeeDevelopmentPlanItemEditionApiCall = ({
  companyId,
  employeeId,
  developmentPlanId,
  itemId,
  developmentPlanTemplateItemId,
  value,
}: {
  companyId: number;
  employeeId: number;
  developmentPlanId: number;
  itemId: number;
  developmentPlanTemplateItemId: number;
  value: string;
}) =>
  axios.put<DevelopmentPlanItem>(
    `/api/companies/${companyId}/employees/${employeeId}/development_plans/${developmentPlanId}/items/${itemId}`,
    { developmentPlanTemplateItemId, value }
  );

export const doEmployeeDevelopmentPlanItemDeletionApiCall = ({
  companyId,
  employeeId,
  developmentPlanId,
  itemId,
}: {
  companyId: number;
  employeeId: number;
  developmentPlanId: number;
  itemId: number;
}) =>
  axios.delete<DevelopmentPlanItemResponse>(
    `/api/companies/${companyId}/employees/${employeeId}/development_plans/${developmentPlanId}/items/${itemId}`
  );

export const doEmployeeAssessmentsReportFetchApiCall = ({
  companyId,
  employeeId,
}: {
  companyId: number;
  employeeId: number;
}) =>
  axios.get<EmployeeAssessmentsReport[]>(
    `/api/companies/${companyId}/employees/${employeeId}/reports`
  );

export const doEmployeeAssessmentReportFetchApiCall = ({
  companyId,
  employeeId,
  assessmentId,
}: {
  companyId: number;
  employeeId: number;
  assessmentId: number;
}) =>
  axios.get<EmployeeAssessmentReport>(
    `/api/companies/${companyId}/employees/${employeeId}/reports/${assessmentId}`
  );
